import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';
import Upperbox from '../components/Upperbox';

export const International = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Upperbox />
      <NavBar />
      <div className='tax-page'>
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">International Business Tax Forms</h1>
            <Link to="/businessservicespage" className="tax-notification-body">Go Back</Link>
          </div>
        </div>

        <div className='tax-content-container'>
          <h1 className='tax-section-title'>
            Comprehensive International Business Tax Forms and Services at Sumukha Tax Filers.
          </h1>
          <p className='tax-section-description'>
            In today's global economy, businesses often engage in international transactions, making it essential to navigate the complexities of international tax regulations. At Sumukha Tax Filers., we specialize in assisting businesses with international tax compliance, ensuring that all necessary forms are completed accurately and submitted on time. Our team of experienced Certified Public Accountants (CPAs) and Enrolled Agents (EAs) is here to guide you through the intricacies of international business tax forms and reporting requirements.
          </p>
          <h2 className='tax-subheading'>Why Choose Sumukha Tax Filers. for International Business Tax Forms?</h2>
          <ul className='tax-section-description'>
            <li><strong>Expertise:</strong> Our professionals have in-depth knowledge of international tax laws, treaties, and compliance requirements, helping you understand your obligations and avoid costly penalties.</li>
            <li><strong>Tailored Solutions:</strong> We recognize that every international business is unique. We tailor our services to meet your specific needs, ensuring compliance with both U.S. and foreign tax regulations.</li>
            <li><strong>Global Perspective:</strong> Our team stays updated on international tax developments and trends, providing you with the insights needed to make informed business decisions.</li>
          </ul>
          <h2 className='tax-subheading'>Key International Business Tax Forms We Handle</h2>
          <p className='tax-section-description'>
            At Sumukha Tax Filers., we offer assistance with a variety of international tax forms, including:
          </p>
          <ol className='tax-section-description'>
            <li><strong>Form 1120-F:</strong> U.S. Income Tax Return of a Foreign Corporation. Used by foreign corporations engaged in a trade or business in the United States to report income, deductions, and tax liability.</li>
            <li><strong>Form 5471:</strong> Information Return of U.S. Persons With Respect to Certain Foreign Corporations. Required for U.S. citizens and residents who are officers, directors, or shareholders in certain foreign corporations, providing detailed information about the foreign entity.</li>
            <li><strong>Form 5472:</strong> Information Return of a 25% Foreign-Owned U.S. Corporation or a Foreign Corporation Engaged in a U.S. Trade or Business. Required for U.S. corporations with foreign ownership to report transactions with foreign related parties.</li>
            <li><strong>Form 8865:</strong> Return of U.S. Persons With Respect to Certain Foreign Partnerships. Used by U.S. persons who own an interest in a foreign partnership to report income, deductions, and other relevant information.</li>
            <li><strong>Form 926:</strong> Return by a U.S. Transferor of Property to a Foreign Corporation. Required when a U.S. person transfers property to a foreign corporation in certain circumstances, detailing the transferred property.</li>
            <li><strong>Form 1042-S:</strong> Foreign Person's U.S. Source Income Subject to Withholding. Used to report income paid to foreign persons, including non-resident aliens and foreign entities, and any withholding on that income.</li>
          </ol>
          <h2 className='tax-subheading'>Our International Tax Services</h2>
          <p className='tax-section-description'>
            At Sumukha Tax Filers., we offer a full range of international tax services, including:
          </p>
          <ul className='tax-section-description'>
            <li><strong>International Tax Planning:</strong> We help you develop strategies to minimize your international tax liability while ensuring compliance with all regulations.</li>
            <li><strong>Cross-Border Tax Compliance:</strong> Our team ensures that all international tax forms are completed accurately and submitted on time to both U.S. and foreign tax authorities.</li>
            <li><strong>Consultation on Tax Treaties:</strong> We provide guidance on applicable tax treaties that may affect your business operations and tax obligations.</li>
            <li><strong>Audit Support:</strong> In the event of an audit by tax authorities, we provide comprehensive support and representation.</li>
          </ul>
          <h2 className='tax-subheading'>Get Started Today</h2>
          <p className='tax-section-description'>
            Navigating international tax obligations can be challenging, but Sumukha Tax Filers. is here to help. Our team of expert CPAs and EAs is dedicated to ensuring that your international business tax forms are handled accurately and efficiently. Contact us today to schedule a consultation and discover how we can support your international tax compliance needs!
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};
export default International;